<template>
<div>
    <el-row class="cs-contentContainer">
        <el-col :span="4" class="cs-main-left-container">
            <navigator></navigator>
        </el-col>
        <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
            <div class="cs-fullHeight cs-contentContainer-right">
                <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
                    <el-row>
                        <el-col>
                            <span class="cs-title">价格查询</span>
                            <el-tabs v-model="activeCourseType" type="card">
                                <el-tab-pane :key="item.Value" v-for="item in courseTypes" :label="item.Text" :name="item.Value">
                                    <span slot="label"> {{item.Text}} </span>
                                    <el-row class="cs-filter-row">
                                        <el-col :span="16">
                                            <el-row>
                                                <el-col :span="4">
                                                    <el-select placeholder="大学" :filterable="true" v-model="searchCondition.GroupNumber" @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                                                        <el-option v-for="item in universityGroups" :key="item.GroupNumber" :label="item.NameValue" :value="item.GroupNumber">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                                <!-- <el-col :span="4">
                                                    <el-select placeholder="收费类型" v-model="searchCondition.CourseCategory" @change="onSearchConditionChanged" size="medium" class="margin-left-20px">
                                                        <el-option v-for="item in courseCategoryList" :key="item.Key" :label="item.Value" :value="item.Key">
                                                        </el-option>
                                                    </el-select>
                                                </el-col> -->
                                                <el-col :span="5">
                                                    <el-input placeholder="课程名" size="medium" clearable suffix-icon="el-icon-search" v-model="searchCondition.CourseName" @change="onSearchConditionChanged" class="margin-left-20px"> </el-input>
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                        <el-col :span="8">
                                            <div class="pull-right">
                                                <el-button type="primary" v-if="hasPermission" :loading="syncLoading" @click="onSyncGoogleSheet">同步Google Sheet</el-button>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <hr />
                                    <el-row class="grid-content">
                                        <el-col>
                                            <el-row class="cs-priceQuery-descRow">
                                                <el-col :span="16">
                                                    <span class="cs-priceQuery-desc">速成课程全新价格机制是根据老师上课次数递减的，不再按周递减，老师每上一次课，价格下调一次</span>
                                                    <span class="cs-priceQuery-desc">因此，此价目表仅作为参考，因为这个价目表是假定老师每周只上一节课来进行价格递减的</span>
                                                </el-col>
                                            </el-row>
                                            <el-table v-if="!!currentTerm" ref="priceTable" v-loading="loading" :data="currentPagePrices" :cell-class-name="cellStyle" 
                                            :header-row-class-name="'el-table-header'" max-height="550">
                                                <el-table-column prop="CourseName" fixed label="课程名称" width="120">
                                                </el-table-column>
                                                <el-table-column prop="SpecialSituation" label="特殊情况" width="120">
                                                </el-table-column>
                                                <el-table-column prop="OriginalPrice" label="原价" width="60">
                                                </el-table-column>
                                                <el-table-column v-if="hasPermission" prop="IsDecreasedPrice" label="递减价" width="80">
                                                    <template slot-scope="scope">
                                                        <span>{{scope.row.IsDecreasedPrice ? "是" : ""}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column v-if="hasPermission" prop="DecreasedUnitPrice" label="递减单价" width="80">
                                                </el-table-column>
                                                <el-table-column v-if="hasPermission" prop="BasePrice" label="底价" width="80">
                                                </el-table-column>
                                                <el-table-column prop="AdvanceEnrollmentPrice" label="提前招生" width="80">
                                                </el-table-column>
                                                <el-table-column v-for="week in weekList" :key="week" :label="'W' + week" :class-name="getHighlightWeek(week)" width="110">
                                                    <template slot-scope="scope">
                                                        <span>{{getWeekPrice(scope.row, week)}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="Discount9Price" label="9折" width="80">
                                                </el-table-column>
                                                <el-table-column prop="Discount85Price" label="85折" width="80">
                                                </el-table-column>
                                                <el-table-column prop="Discount8Price" label="8折" width="80">
                                                </el-table-column>
                                                <el-table-column prop="Discount7Price" label="7折" width="80">
                                                </el-table-column>
                                                <el-table-column prop="Discount6Price" label="6折" width="80">
                                                </el-table-column>
                                                <el-table-column prop="Discount5Price" label="5折" width="80">
                                                </el-table-column>
                                                <el-table-column prop="Discount4Price" label="4折" width="80">
                                                </el-table-column>
                                                <el-table-column prop="Discount3Price" label="3折" width="80">
                                                </el-table-column>
                                                <el-table-column prop="NormalGroup" label="内部价" width="80">
                                                </el-table-column>
                                                <el-table-column prop="AssureScore" label="保分" width="110">
                                                </el-table-column>
                                                <el-table-column prop="Information" label="资料" width="150">
                                                </el-table-column>
                                                <el-table-column prop="IsYearCourse" label="年课" width="80">
                                                    <template slot-scope="scope">
                                                        <span>{{scope.row.IsYearCourse ? "是" : ""}}</span>
                                                    </template>
                                                </el-table-column>
                                                
                                            </el-table>
                                            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="currentPageSize" layout="total, sizes, prev, pager, next, jumper" :total="recordTotal">
                                            </el-pagination>
                                        </el-col>
                                    </el-row>
                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-col>
    </el-row>
</div>
</template>

<style lang="scss">
body{
    .cs-filter-row{
        padding: 20px 0 0 0;
    }
}

.cs-priceQuery-descRow{
    margin: 0 0 10px 0;
    .cs-priceQuery-desc{
        font-weight: bold;
        display: block;
    }
}

.dateSmall {
    font-size: 6px;
}

.titleCenter {
    text-align: center !important;
}

.highlight {
    text-align: center !important;
    background-color: aqua !important;
}
</style>

<script>
import navigator from "../../components/navigator";
import {
    getUniversityGroups,
    getCourseCategoryList,
    getCurrentTerm,
    SyncGoogleSheet
} from "../../service/common.service";
import {
    getSpeedupCoursePrice
} from "../../service/speedupCourse.service.js";
import global_ from "../../core/global";

export default {
    data() {
        let weekCount = 24;
        let list = [];
        for(let i = 1; i <= weekCount; i ++){
            list.push(i);
        } 
        return {
            courseTypes: [],
            activeCourseType: "1",
            paginationOption: {},
            universityGroups: [],
            courseCategoryList: [],
            searchCondition: {
                GroupNumber: "",
                CourseCategory: "",
                CourseName: ""
            },
            currentPage: 1,
            currentPageSize: 20,
            recordTotal: 1,
            loading: false,
            coursePriceList: [],
            currentPagePrices: [],
            currentTerm: null,
            syncLoading:false,
            weekList : list,
            hasPermission: this.USERMANAGER.isAdmin || this.USERMANAGER.isAcademicDirector || this.USERMANAGER.isCampusPresident || this.USERMANAGER.isRegionCEO 
        }
    },
    components: {
        navigator
    },
    created() {
        getCurrentTerm().then(result => {
            if (!!result && result.success) {
                this.currentTerm = result.data;
            }
            this.loadSpeedupCoursePrices();
        });
        this.courseTypes = [{
            Text: "大学补习",
            Value: "1"
        }];//getCourseType();
        getUniversityGroups().then(result => {
            if (!!result && result.success) {
                this.universityGroups = result.data;
                if (!!this.universityGroups && this.universityGroups.length >0){
                    this.searchCondition.GroupNumber = this.universityGroups[0].GroupNumber;
                    this.loadSpeedupCoursePrices();
                }
            }
        });
        getCourseCategoryList(parseInt(this.activeCourseType)).then(result => {
            if (!!result && result.success) {
                this.courseCategoryList = result.data;
            }
        });
        
    },
    mounted() {},
    computed:{
        getHighlightWeek(){
            let currentWeek  = this.currentTerm.CurrentWeek;
            return function(week) {
               
                let headerClass = "titleCenter";
                // if (week == this.currentTerm.CurrentWeek || (week == 13 && this.currentTerm.CurrentWeek > 13)){
                if (week == this.currentTerm.CurrentWeek){
                     headerClass = "highlight";
                 }
                return headerClass;
            }
        },
    },
    methods: {
        getWeekPrice(row, week){
            if (!!row && !!row.WeekPriceList){
                let weekPrice = row.WeekPriceList.find(i => i.Week == week);
                if (!!weekPrice){
                    return weekPrice.Price;
                }
            }
            return "";
        },
        cellStyle(cell) {
            let cellClass = "";
            let label = cell.column.property;
            if (!!label && label.indexOf('W') == 0){
                let str =label.replace('W','');
                if (!isNaN(str)){
                    let week = parseInt(str);
                    if (!!this.currentTerm){
                        if (week == this.currentTerm.CurrentWeek){
                            cellClass = "highlight"
                        }
                    }
                }
            }
            
            if (!cellClass) {
                if ((cell.rowIndex + 1) % 2 == 1) {
                    cellClass = "el-table-cell-single";
                } else {
                    cellClass = "el-table-cell-double";
                }
            }
            return cellClass;
        },
        loadSpeedupCoursePrices() {
            if (!this.currentTerm){
                return;
            }
            if (!this.universityGroups || this.universityGroups.length == 0){
                return;
            }

            this.loading = true;
            getSpeedupCoursePrice(
                this.searchCondition.GroupNumber,
                this.searchCondition.CourseName
            ).then(result => {
                if (!!result && result.success) {
                    this.coursePriceList = result.data;
                    this.recordTotal = this.coursePriceList.length;
                    this.currentPage = 1;
                    this.getCurrentPagePrices();
                }
                this.loading = false;
            });
        },
        getCurrentPagePrices() {
            let start = (this.currentPage - 1) * this.currentPageSize;
            let end = start + this.currentPageSize;
            this.currentPagePrices = this.coursePriceList.slice(start, end);
        },
        onSearchConditionChanged() {
            this.loadSpeedupCoursePrices();
        },
        handleSizeChange(value) {
            this.currentPageSize = value;
            this.currentPage = 1;
            this.getCurrentPagePrices();
        },
        handleCurrentChange(index) {
            this.currentPage = index;
            this.getCurrentPagePrices();
        },
        onSyncGoogleSheet() {
            this.syncLoading=true;
            let notice = this.$notify({
                title: '提示',
                message: '正在为您同步Google Sheet的价目表，您可以继续其它操作，同步完成后，本提示会自动关闭',
                showClose: false,
                duration: 0
            });
            SyncGoogleSheet().then(result => {
                notice.close();
                 this.syncLoading=false;
                if (!!result && result.success) {
                    this.$notify({
                        title: '成功',
                        message: '已经成功完成价目表的同步',
                        type: 'success'
                    });
                    this.loadSpeedupCoursePrices();
               
                }else{
                    this.$notify.error({
                        title: '错误',
                        message: result.message
                    });
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/frontDesk/priceQuery.vue